// extracted by mini-css-extract-plugin
export default {"title":"Products_title__vQukI","description":"Products_description__OG7JM","card":"Products_card__aEPkR"};